import React from 'react';
import { Title } from '../title';
import { ContainerBase } from '../containers';
import clsx from 'clsx';
import { CardAwards } from './CardAwards';

export const Awards: React.FC = () => {
	return (
		<ContainerBase className={clsx('space-y-16 pb-14 md:pb-16 relative')}>
			<div className="py-[60px] lg:px-[60px] w-full flex flex-col justify-center items-center">
				<Title
					className="lg:max-w-[578px] xl:max-w-[768px] !gap-10"
					description="Lowey Dannenberg has earned industry recognition for legal excellence."
				>
					Awards
				</Title>
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-8 lg:mt-10 px-8 lg:px-0">
					<CardAwards type="super-lawyers" />
					<CardAwards type="preeminent" />
				</div>
			</div>
		</ContainerBase>
	);
};
